import React from 'react'
import { withIcon } from '../../withIcon'

function UsersIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M15.6001 19.9999V18.198C15.6001 17.2421 15.2208 16.3254 14.5457 15.6496C13.8706 14.9737 12.9549 14.594 12.0001 14.594H6.60004C5.64525 14.594 4.72956 14.9737 4.05443 15.6496C3.37929 16.3254 3 17.2421 3 18.198V19.9999" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.30012 12.0041C11.2884 12.0041 12.9002 10.3905 12.9002 8.40011C12.9002 6.40969 11.2884 4.79614 9.30012 4.79614C7.31188 4.79614 5.70009 6.40969 5.70009 8.40011C5.70009 10.3905 7.31188 12.0041 9.30012 12.0041Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 20V18.198C20.9994 17.3995 20.7339 16.6238 20.2452 15.9927C19.7565 15.3616 19.0723 14.9108 18.3 14.7112" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 4C16.5721 4.19898 17.0792 4.65096 17.4413 5.28467C17.8034 5.91838 18 6.69778 18 7.5C18 8.30222 17.8034 9.08162 17.4413 9.71533C17.0792 10.349 16.5721 10.801 16 11" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default withIcon(UsersIcon)
